import React from 'react'

export default function CompositeSegment ({displayName, compositeFilledIn, compositeNotFilledIn, strokeDashoffset}) {
  return (
    <circle
      key={`composite${displayName}`} 
      className="DonutSegment" 
      cx="21" cy="21" r="15.91549430918954" 
      fill="transparent" 
      stroke={`url(#${displayName.toLowerCase()}-radial)`} 
      strokeWidth="5"
      strokeDasharray={`${compositeFilledIn} ${compositeNotFilledIn}`} 
      strokeDashoffset={strokeDashoffset}>
    </circle>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/CompositeSegment.js